// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ox-y","title":"styles_title__2KdD6"};